import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import injectStyle from './style';

injectStyle()

ReactDOM.render(<App/>, document.getElementById('root'));